import { RG_TYPE } from '../../types/rg-type.js';

const DefaultWall = {
    type: RG_TYPE.Wall,
    modulousId: 'WPA|01|',
    size: [6, 3, 0.1],
    anchor: [0.5, 0, 0.5],
    name: 'wall',
    color: '#A7DBD8',
    children: []
};

export { DefaultWall };
//# sourceMappingURL=default-wall.js.map
